/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon16Light = forwardRef('SecurityLockOpenIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.5 9a1 1 0 0 1-.5.866V11a.5.5 0 0 1-1 0V9.866A1 1 0 1 1 8.5 9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3.5a3.5 3.5 0 1 1 7 0v1a.5.5 0 0 1-1 0v-1a2.5 2.5 0 0 0-5 0V5h.5A2.5 2.5 0 0 1 13 7.5v4a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 11.5v-4A2.5 2.5 0 0 1 4.5 5H9V3.5ZM4.5 6h6A1.5 1.5 0 0 1 12 7.5v4a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 3 11.5v-4A1.5 1.5 0 0 1 4.5 6Z" })));
});
